import React from 'react';

const defaultValue = {
    repoDescription: "",
};

export const AppContext = React.createContext(defaultValue);
